import { VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { ReactNode } from 'react';

export const SignedOutFormContainer: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Box
      flex={1}
      width="full"
      height="full"
      justifyContent={{ md: 'center', lg: 'center' }}
      alignItems={{ md: 'center', lg: 'flex-end' }}
      paddingX={{ lg: Spacing['stack.md'] }}>
      <VStack
        p={Spacing['stack.lg']}
        width={{ base: 'full', md: '2/3', lg: '1/3', xl: '1/4' }}
        height={{ base: 'full', md: '5/6', lg: '5/6' }}
        bgColor={Color['neutral.white']}
        borderRadius={BoxBorder.heavy}
        space={Spacing['stack.xxs']}
        justifyContent="center"
        alignItems="normal"
        _web={{ minHeight: 'fit-content' }}>
        {children}
      </VStack>
    </Box>
  );
};
